import { cn } from "@/utils/cn";

export default function CheckCircelActiveIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-[#101828]", className)}
    >
      <rect width="20" height="20" rx="10" fill="currentColor" />
      <path
        d="M14.6654 6.5L8.2487 12.9167L5.33203 10"
        stroke="white"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const displayName = "CheckCircleActiveIcon";
